export default __webpack_public_path__ + "static/media/SecureUserExp.Left.e3a129f1.png";